import { render, staticRenderFns } from "./CommentAudit.vue?vue&type=template&id=39611c71&scoped=true"
import script from "./CommentAudit.vue?vue&type=script&lang=js"
export * from "./CommentAudit.vue?vue&type=script&lang=js"
import style0 from "./CommentAudit.vue?vue&type=style&index=0&id=39611c71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39611c71",
  null
  
)

export default component.exports